import Button from "./Button";

const MobileFiltersContainer = (props) => {
  return (
    <div
      className={`lg:hidden w-[90%] px-5 fixed top-0 h-screen overflow-y-auto bg-white ${
        props.isOpen ? "left-0" : "-left-full"
      } transition-all duration-400 z-50 border-r-primary border-r-solid border-r-[1px]`}
    >
      <div className="w-full flex flex-row items-end mt-5">
        <div
          className="ml-auto lg:hidden underline font-bold mb-2 text-xs cursor-pointer hover:opacity-50 "
          onClick={props.closeMobileFilters}
        >
          Close filters
        </div>
      </div>
      {props.children}
      <div className="my-5">
        <Button label={"Apply filters"} action={props.closeMobileFilters} />
      </div>
    </div>
  );
};
export default MobileFiltersContainer;
